import React from 'react';
import { css } from 'linaria';
import { breakpointLargeHandset } from 'common/constants';
import { useTranslation } from 'next-i18next';
const PocketWorthyWrapper = "p1gsts5b";
export function PocketWorthy() {
  const {
    t
  } = useTranslation();
  return <div className={PocketWorthyWrapper}>
      {t('discover:pocket-worthy', 'Pocket worthy')}
      <span>{t('discover:stories-to-fuel-your-mind', 'Stories to fuel your mind.')}</span>
    </div>;
}

require("./pocket-worthy.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./pocket-worthy.js");